module.exports = __webpack_public_path__ + "static/img/4.27c2d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/4.png
// module id = xMwE
// module chunks = 10